<div *ngIf="isValid === false" class="errors-container" [ngClass]="cssClass">
  <div class="errors-section"></div>
</div>
